module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    class: {
      'alert-box': true, '-danger': _vm.type === 'error', '-success': _vm.type === 'success'
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.message) ? _c('span', [_vm._v(_vm._s(_vm.message))]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ee48436"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Alert.vue
// module id = 267
// module chunks = 1